import styled from "@emotion/styled";

export const InputFocusVirtualKeyboardPadding = styled.div`
  label: VirtualKeyboardPadding;
  padding-bottom: var(--keyboard-height, 0px);
`;
